import React from 'react';
import { Switch } from 'antd';
import { AiReceptionistStats } from '../../../../domain/models/AiReceptionist';

interface DonaStatusSectionProps {
  assistantName: string;
  userFirstName: string;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  stats: AiReceptionistStats;
}

const DonaStatusSection: React.FC<DonaStatusSectionProps> = ({
  assistantName,
  userFirstName,
  enabled,
  onEnabledChange,
  stats,
}) => {
  const name = assistantName || 'Donna';

  return (
    <div className="receptionist-ai-detail-page__section receptionist-ai-detail-page__section--flush">
      <div className="receptionist-ai-detail-page__status-row">
        <div className="receptionist-ai-detail-page__section-heading">
          <h3 className="receptionist-ai-detail-page__section-title">
            {userFirstName ? `${name} décroche pour ${userFirstName}` : `${name} décroche à votre place`}
          </h3>
          <p className="receptionist-ai-detail-page__section-subtitle">
            Quand il ne répond pas, refuse, ou est déjà en ligne.
          </p>
        </div>
        <Switch checked={enabled} onChange={onEnabledChange} />
      </div>

      <div className="receptionist-ai-detail-page__stats-row">
        <div className="receptionist-ai-detail-page__stat">
          <span className="receptionist-ai-detail-page__stat-value">{stats.callsCount}</span>
          <span className="receptionist-ai-detail-page__stat-label">appels captés ce mois</span>
        </div>
        <div className="receptionist-ai-detail-page__stat">
          <span className="receptionist-ai-detail-page__stat-value">
            {Math.round(stats.callDurationMinutes)}
            <span className="receptionist-ai-detail-page__stat-unit">min</span>
          </span>
          <span className="receptionist-ai-detail-page__stat-label">prises en charge</span>
        </div>
        <div className="receptionist-ai-detail-page__stat">
          <span className="receptionist-ai-detail-page__stat-value">{stats.opportunitiesCount}</span>
          <span className="receptionist-ai-detail-page__stat-label">opportunités</span>
        </div>
      </div>

      {stats.callsCount > 0 && (
        <p className="receptionist-ai-detail-page__stats-footer">
          {stats.callsCount > 1
            ? `Sans ${name}, ces ${stats.callsCount} appels seraient partis en messagerie.`
            : `Sans ${name}, cet appel serait parti en messagerie.`}
          {stats.opportunitiesCount > 0 &&
            ` ${stats.opportunitiesCount} ${stats.opportunitiesCount > 1 ? 'venaient' : 'venait'} d’un acheteur, d’un vendeur ou d’un propriétaire.`}
        </p>
      )}
    </div>
  );
};

export default DonaStatusSection;
